import React from "react";
import {AlertTooltip} from "./base/AlertTooltip";
import {DashboardCell} from "./base/DashboardCell";

export class DashboardTodayCell extends DashboardCell {
    alertCssClasses() {
        let cssClasses = "";
        if (this.props.data.alert_snoozed) {
            cssClasses = '-snoozed';
        }

        if (this.props.data.alert_level !== 'normal') {
            cssClasses = `${cssClasses} alert -${this.props.data.alert_level}`;
        } else {
            cssClasses = `${cssClasses} no-alert`;
        }

        return cssClasses;
    }

    renderCellValue() {
        if (this.props.data.alert_level === 'normal') {
            return this.props.data.formatted_value;
        } else {
            return this.props.data.fluctuation_percentage;
        }
    }

    renderTooltip() {
        if (this.props.data.alert_level !== 'normal') {
            return <AlertTooltip comparisonWithAverageValue={this.props.data.fluctuation}
                                 metricExpextedValue={this.props.data.formatted_expected_value}
                                 metricName={this.props.metricName}
                                 trackConversionsUsingAnalytics={this.props.data.track_conversions_using_analytics}
                                 metricValue={this.props.data.formatted_value}
                                 hasMetaActionsAndAreNotSet={this.props.data.has_meta_actions_and_are_not_set}/>;
        } else {
            return null;
        }
    }

    render() {
        let arrowClass = '';
        if (this.props.data.alert_level !== 'normal') {
            arrowClass = '-' + this.props.data.fluctuation.toLowerCase();
        }
        return (
            <td className={`${this.alertCssClasses()} ${arrowClass} single-data ${this.processingCssClasses()}`}>
                {this.renderWarningIfNecessary()}
                {this.renderCellValue()}
                {this.renderTooltip()}
            </td>
        )
    }
}